// Jarda slider 
import Splide from '@splidejs/splide';
export const init = () => {
    if (document.querySelector('.carousel_type-2')) {
        const carousel2 = document.querySelectorAll('.carousel_type-2');
        let data = [];
        // Source hide/render logic 
        const source_el_all = document.querySelectorAll('.js-source-type-2');

        if (source_el_all) {
            var render_source = function (sliderId, itemId) {
                if (data[sliderId].sourceStrings.length) {
                    setTimeout(function () {
                        data[sliderId].sourceStringsElements[0].textContent = data[sliderId].sourceStrings[itemId];
                    }, 280);
                }
            }
        }


        // Decoration graphic render true/false
        var render_decoration = function (sliderId, itemId) {
            if (data[sliderId].decoration.length) {

                if (data[sliderId].decorationElements[0]) {
                    setTimeout(function () {
                        if (data[sliderId].decoration[itemId] === "true") {
                            data[sliderId].decorationElements[0].classList.add('decoration-active');
                        } else {
                            data[sliderId].decorationElements[0].classList.remove('decoration-active');
                        }
                    }, 280);
                }


            }
        }

        carousel2.forEach((item, index) => {
            const splideCarousel2 = new Splide(item, {
                type: 'fade',
                arrows: false,
                pagination: true,
                interval: 2000,
                gap: 32,
                noDrag: 'a, p',
                perPage: 1,
                perMove: 1,
                classes: {
                    pagination: 'splide__pagination g-pagination__type-1',
                },
            });
            splideCarousel2.mount();

            const arrowLeft = item.querySelector('.button--prev');
            const arrowRight = item.querySelector('.button--next');

            arrowLeft?.addEventListener('click', () => splideCarousel2.go('<'));
            arrowRight?.addEventListener('click', () => splideCarousel2.go('>'));

            // Define data for all sliders
            data = [
                ...data,
                {
                    decoration: [...item.querySelectorAll("[data-decoration]")].map(function (cur) {
                        return cur.dataset.decoration;
                    }),
                    decorationElements: [item.querySelector('[data-decoration]') && item.querySelector('[data-decoration]').closest('.js-slider-type2')],
                    sourceStrings: [...item.querySelectorAll('.data-source-type-2')].map(function (cur) {
                        return cur.textContent;
                    }),
                    sourceStringsElements: [item.querySelector('.data-source-type-2') && item.querySelector('.data-source-type-2').closest('.js-slider-type2').querySelector('.js-source-type-2')],
                }
            ];

            render_source(index, 0);

            render_decoration(index, 0);



            // Solution for arrows of slider. 
            const slidesLenght = splideCarousel2.length - 1;
            const { Controller } = splideCarousel2.Components;

            // Remove all arrows if we have only one slide.
            slidesLenght === 0 && arrowRight?.classList.add('u-js-hide');

            splideCarousel2.on('move', (newIndex) => {
                switch (newIndex) {
                    case 0:
                        arrowLeft?.classList.add('u-js-hide');
                        arrowRight?.classList.remove('u-js-hide');
                        break;
                    case Controller.getEnd():
                        arrowRight?.classList.add('u-js-hide');
                        arrowLeft?.classList.remove('u-js-hide');
                        break;
                    default:
                        arrowLeft?.classList.remove('u-js-hide');
                        arrowRight?.classList.remove('u-js-hide');
                }

                if (source_el_all) {
                    render_source(index, newIndex);
                }
                render_decoration(index, newIndex);

            });

            if (item.classList.contains('carousel_type-equal-height')) {

                let updateHeight = () => {
                    let values = [];
                    splideCarousel2.Components.Slides.forEach(function (iteratee, excludeClones) {
                        values[excludeClones] = iteratee.slide.offsetHeight;
                        iteratee.slide.style.height = "100%";
                    });
                    Array.prototype.max = function () {
                        return Math.max.apply(null, this);
                    };

                    let slide = splideCarousel2.Components.Slides.getAt(splideCarousel2.index).slide;
                    slide.parentElement.style.height = values.max() + 'px';

                };

                splideCarousel2.on('active resized', updateHeight);
            }
        })
    }

}

